exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".settings-section.settings-section.settings-section.settings-section[class][data-v-02dff8d2]{padding:0 1em}.settings-section.settings-section.settings-section.settings-section[class] .field-label[data-v-02dff8d2]{padding-left:13px;padding-right:0}.settings-section.settings-section.settings-section.settings-section[class][data-v-02dff8d2] .page-section-main{padding-top:1px}.settings-section.settings-section.settings-section.settings-section[class][data-v-02dff8d2] .page-section-main .form-group{margin-bottom:3px}.settings-section.settings-section.settings-section.settings-section[class][data-v-02dff8d2] .page-section-main .form-group .form-control{font-size:12px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-02dff8d2","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/_modules/Approvals/Approval-list/index.vue
// module id = MASG
// module chunks = 12